import { defineStore } from 'pinia';

export const useFormErrorsStore = defineStore('formErrors', {
  state: () => ({
    errors: {} as Record<string, string>,
  }),
  actions: {
    setErrors(errors: Record<string, string>) {
      this.errors = errors;
    },
    clearErrors() {
      this.errors = {};
    },
  },
});
